import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { IApiResponse } from '../../../../shared/models/api-response';
import { CreateSrsBallotModel } from '../models/sr/sr-committee-search-data';
import { ISrsBallotUpdateDatesRequest } from '../models/sr/srs-update-dates-request';
import { ISubmitSrsBallotVotesRequest } from '../models/sr/submit-srs-ballot-votes-request';
import { ISubmitSrsProxyVotesRequest } from '../models/sr/submit-srs-proxy-votes-request';
import { FinaliseSrsBallotRequest } from '../models/sr/finalise-srs-ballot-request';
import { ISrsBallotVote } from '../models/sr/srs-vote';
import { ISrUpdateNoteRequest } from '../models/sr/sr-update-note-request';
import { SrsBallotReviewStage } from '../models/sr/srs-ballot-review-stage';
import { IConnectEnumValue } from '../../../../shared/models/connect-enum';
import { convertObjectToFormData } from '../../../../shared/utilities/form-data-utility';

@Injectable({
  providedIn: 'root'
})
export class SrsBallotService {

  baseUrl: string = `${environment.servicesUrl.ballot}api/ballots/srs`;

  constructor(
    private http: HttpClient
  ) { }


  public createSRSBallot(createSrsBallot: CreateSrsBallotModel): Observable<IApiResponse<CreateSrsBallotModel>> {
    return this.http
      .post<IApiResponse<CreateSrsBallotModel>>(`${this.baseUrl}`, createSrsBallot)
  }


  public getSRSBallot(ballotId: string): Observable<IApiResponse<any>> {
    return this.http
      .get<IApiResponse<any>>(`${this.baseUrl}/${ballotId}`);
  }

  public getSrsBallotVoteHistory(ballotId: string, voteId: string) : Observable<IApiResponse<ISrsBallotVote>> {
    return this.http
      .get<IApiResponse<ISrsBallotVote>>(`${this.baseUrl}/${ballotId}/votes/${voteId}/history`);
  }

  public updateBallotDates(ballotId: string, request: ISrsBallotUpdateDatesRequest): Observable<IApiResponse<any>> {
    return this.http
      .put<IApiResponse<any>>(`${this.baseUrl}/${ballotId}/dates`, request);
  }

  public updateBallotNote(request: ISrUpdateNoteRequest): Observable<IApiResponse<any>> {
    return this.http
      .put<IApiResponse<string>>(`${this.baseUrl}/${request.ballotId}/note`, request);
  }

  public placeSRSVote(request: ISubmitSrsBallotVotesRequest) : Observable<HttpEvent<any>> {

    const formData = convertObjectToFormData(request);

    return this.http
      .post<HttpEvent<any>>(`${this.baseUrl}/${request.ballotId}/votes/${request.voteIds[0]}`, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }

  public finaliseSrsBallot(request: FinaliseSrsBallotRequest) : Observable<IApiResponse<any>> {
    return this.http
      .post<IApiResponse<FinaliseSrsBallotRequest>>(`${this.baseUrl}/${request.ballotId}/finalise`, request);
  }

  public submitProxyVotes(request: ISubmitSrsProxyVotesRequest) : Observable<HttpEvent<any>> {
    const formData = convertObjectToFormData(request);

    return this.http.post<HttpEvent<any>>(`${this.baseUrl}/${request.ballotId}/proxy-votes`, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }

  public getSrsBallotReviewStageEnums() : Observable<IApiResponse<IConnectEnumValue<SrsBallotReviewStage>[]>> {
    return this.http.get<IApiResponse<IConnectEnumValue<SrsBallotReviewStage>[]>>(`${this.baseUrl}/get-ballot-review-stages`);
  }
}
